/**
 * Image paths for AI Chat components
 */
export const AI_CHAT_IMAGE = '/img/ufe/ai/ai_chat.svg';

export const AI_CHAT_BLACK_IMAGE = '/img/ufe/ai/ai_chat_black.svg'; //if isGenAINewUIEnabled == true
